import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { useTableContext } from '../TableContext';
import { useTableCellBorderStyles, useTableStyles } from '../Table.styles';
import { useCardContext } from '../../Card/CardContext';
import { deepMerge } from '../../../utils/deepMerge';
import { CSS_SPECIFICITY } from '../../../constants/CSSSpecificity';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHeaderCell = styled.th.withConfig({
  displayName: "TableHeaderCell__StyledHeaderCell"
})(({
  theme,
  $exteriorBorders,
  $cssStyles,
  $inCard,
  $disableHover
}) => {
  const tableCellBorderStyles = useTableCellBorderStyles({
    interiorBorders: true,
    isHeader: true,
    exteriorBorders: $exteriorBorders
  });
  const {
    defaultPadding,
    tableHeaderHeight,
    tableCellVerticalAlignment
  } = useTableStyles();
  return deepMerge(Object.assign({}, theme.typography['heading-25'], tableCellBorderStyles, defaultPadding, {
    blockSize: tableHeaderHeight,
    paddingBlockStart: theme.space['200'],
    paddingBlockEnd: theme.space['100'],
    backgroundColor: theme.color['specialty-table-header-default'],
    textAlign: 'left',
    lineHeight: 'normal',
    verticalAlign: tableCellVerticalAlignment
  }, $inCard && !$disableHover && {
    '&, &:hover': {
      backgroundColor: theme.color['specialty-table-header-hover']
    }
  }), $cssStyles,
  // Use higher specificity to override parent table's thead th rule for all user styles
  {
    [CSS_SPECIFICITY.OVERRIDE]: $cssStyles
  });
});
export const TableHeaderCell = props => {
  const {
    domProps,
    callbackProps,
    restProps,
    tokenProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    _exteriorBorders,
    disableHover
  } = useTableContext();
  const {
    inCard
  } = useCardContext();
  return /*#__PURE__*/_jsx(StyledHeaderCell, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles,
    $exteriorBorders: _exteriorBorders,
    $inCard: inCard,
    $disableHover: disableHover
  }));
};